import { render, staticRenderFns } from "./UserInfoModal.vue?vue&type=template&id=0c7fe568&scoped=true&"
import script from "./UserInfoModal.vue?vue&type=script&lang=js&"
export * from "./UserInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7fe568",
  null
  
)

export default component.exports